import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { detect } from 'detect-browser';
import * as _ from 'lodash';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { PaymentApiService } from '../services/payment-api.service';

@Injectable({
  providedIn: 'root',
})
export class MobileGuard  {
  constructor(
    private navigationService: NavigationService,
    private paymentApiService: PaymentApiService,
    private transalte: TranslateService,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const browser = detect();
    const isMobile =
      browser.os === 'iOS' ||
      browser.os === 'Android OS' ||
      browser.os === 'BlackBerry OS' ||
      browser.os === 'Windows Mobile' ||
      browser.os === 'Amazon OS';

    if (state.url.includes('session')) {
      return true;
    }

    // Appcues Trans SSO entry + OAuth callback must stay on desktop auth routes
    if (state.url.includes('auth/trans')) {
      return true;
    }
    if (
      state.url.includes('auth/login') &&
      (next.queryParamMap.has('code') || next.queryParamMap.has('error'))
    ) {
      return true;
    }

    if (state.url.includes('verificationemail') && isMobile) {
      localStorage.setItem('emailVerificationStateUrl', state.url);
      this.navigationService.navigateToMobileAccountActivation(next.queryParams);
    } else if (state.url.includes('verificationemail') && !isMobile) {
      localStorage.setItem('emailVerificationStateUrl', state.url);
      this.navigationService.navigateToAccountActivation(next.queryParams);
    } else if (state.url.includes('subscription-cancellation') && isMobile) {
      this.navigationService.navigateToMobileCancelSubscription(next.queryParams);
    } else if (state.url.includes('subscription-cancellation') && !isMobile) {
      this.navigationService.navigateToCancelSubscription(next.queryParams);
    } else if (state.url.includes('owner-change-accept') && isMobile) {
      this.navigationService.navigateToMobileOwnerChangeAccept(next.queryParams);
    } else if (state.url.includes('owner-change-accept') && !isMobile) {
      this.navigationService.navigateToOwnerChangeAccept(next.queryParams);
    } else if (state.url.includes('owner-change') && isMobile) {
      this.navigationService.navigateToMobileOwnerChange(next.queryParams);
    } else if (state.url.includes('owner-change') && !isMobile) {
      this.navigationService.navigateToOwnerChange(next.queryParams);
    } else if (state.url.includes('accept-premium') && isMobile) {
      if (!_.isEmpty(next.queryParams) && _.get(next, 'queryParams.code')) {
        this.paymentApiService
          .acceptAssignedEmail(next.queryParams.code as string)
          .subscribe((result: boolean) => {
            if (result) {
              this.navigationService.navigateToMobile();
            } else if (result === null) {
              this.navigationService.navigateToMobileAccountActivation();
            } else {
              localStorage.removeItem('token');
              this.navigationService.navigateToMobileRegister();
            }
          });
      } else {
        this.navigationService.navigateToMobile();
      }
    } else if (state.url.includes('accept-premium') && !isMobile) {
      if (!_.isEmpty(next.queryParams) && _.get(next, 'queryParams.code')) {
        this.paymentApiService
          .acceptAssignedEmail(next.queryParams.code as string)
          .subscribe((result: boolean) => {
            if (result) {
              this.navigationService.navigateToHomepage();
            } else if (result === null) {
              this.navigationService.navigateToAccountActivation();
            } else {
              localStorage.removeItem('token');
              this.navigationService.navigateToRegister();
            }
          });
      } else {
        this.navigationService.navigateToHomepage();
      }
    } else if (state.url.includes('admin-change') && isMobile) {
      if (!_.isEmpty(next.queryParams) && _.get(next, 'queryParams.code')) {
        this.paymentApiService
          .acceptRoleChange({
            code: next.queryParams.code as string,
            lang: this.transalte.currentLang,
          })
          .subscribe((message: string) => {
            if (message === 'done') {
              this.navigationService.navigateToMobile();
            } else {
              this.navigationService.navigateToMobileAccountActivation();
            }
          });
      } else {
        this.navigationService.navigateToMobile();
      }
    } else if (state.url.includes('admin-change') && !isMobile) {
      if (!_.isEmpty(next.queryParams) && _.get(next, 'queryParams.code')) {
        this.paymentApiService
          .acceptRoleChange({
            code: next.queryParams.code as string,
            lang: this.transalte.currentLang,
          })
          .subscribe((message: string) => {
            if (message === 'done') {
              this.navigationService.navigateToHomepage();
            } else {
              this.navigationService.navigateToAccountActivation();
            }
          });
      } else {
        this.navigationService.navigateToHomepage();
      }
    } else if (state.url.includes('register') && !state.url.includes('mobile') && isMobile) {
      this.navigationService.navigateToMobileRegister(next.queryParams);
    } else if (state.url.includes('register') && state.url.includes('mobile') && !isMobile) {
      this.navigationService.navigateToRegister();
    } else if (state.url.includes('login') && !state.url.includes('mobile') && isMobile) {
      this.navigationService.navigateToMobileLogin();
    } else if (state.url.includes('login') && state.url.includes('mobile') && !isMobile) {
      this.navigationService.navigateToLogin();
    } else if (state.url.includes('mobile') && !isMobile) {
      this.navigationService.navigateToLogin();
    } else if (!state.url.includes('mobile') && isMobile) {
      this.navigationService.navigateToMobile();
    } else {
      return true;
    }
  }

  public canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(next, state);
  }
}
